import { HsColor } from '../../math-new/objects/color.class';
import type { HsShader } from '../shaders/classes/shader.class';
import { HsMaterial } from './material.class';

export class HsDefaultMaterial<T extends HsShader> extends HsMaterial {
  private readonly shader: T;

  /**
   * @param compileShader Compiles the shader program. Pass false for a material that shares an
   * already compiled shader: recompiling replaces the program and resets the uniforms that the
   * shader's other materials rely on.
   */
  constructor(gl: WebGL2RenderingContext, shader: T, compileShader: boolean = true) {
    super();
    this.shader = shader;
    if (compileShader) {
      this.shader.update(gl);
    }
  }

  public getShader(): T {
    return this.shader;
  }

  public makeCopy(gl: WebGL2RenderingContext): HsDefaultMaterial<T> {
    const material: HsDefaultMaterial<T> = new HsDefaultMaterial<T>(gl, this.getShader());
    material.color = HsColor.makeCopy(this.color);
    return material;
  }
}
